import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { DataItem } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

export type StateSelectorParams = {
  isLoading: boolean
  isSharedView: boolean
  data: Record<string, string | DataItem>
  dataChartType: string
  dataChartScale: string
  sortByAttribute: string | null
  sortByMethod: string | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const store = state.currentData
  return {
    isLoading: state.isLoading,
    isSharedView: state.isSharedView,
    data: store?.data || {},
    dataChartType: block?.get<string>('dataChartType') || 'line',
    dataChartScale: block?.get<string>('dataChartScale') || 'min-max',
    sortByAttribute: block?.get<string>('sortByAttribute') || null,
    sortByMethod: block?.get<string>('sortByMethod') || null
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : next.isLoading
    ? false
    : prev.isSharedView !== next.isSharedView ||
      prev.data !== next.data ||
      prev.dataChartType !== next.dataChartType ||
      prev.dataChartScale !== next.dataChartScale ||
      prev.sortByAttribute !== next.sortByAttribute ||
      prev.sortByMethod !== next.sortByMethod
